// https://www.w3.org/TR/2019/NOTE-wai-aria-practices-1.1-20190207/examples/menu-button/js/PopupMenuLinks.js

const A11Y_SITE_CONTENT = document.querySelectorAll('.js-a11y-site-content')

export default function A11yModal(node, controller) {
  this.KEYCODE_TAB = 9

  this.node = node
  this.controller = controller
}

A11yModal.prototype.open = function () {
  Array.from(A11Y_SITE_CONTENT).forEach((element) => {
    element.setAttribute('aria-hidden', 'true')
  })

  this.node.dataset.classname
    ? this.node.classList.add(`${this.node.dataset.classname}--expanded`)
    : this.node.classList.add('expanded')

  document.body.style.position = 'fixed'
  document.body.style.overflow = 'hidden'

  window.dispatchEvent(new Event('A11yModalOpen'))
  this.captureNavigation()
}

A11yModal.prototype.close = function () {
  Array.from(A11Y_SITE_CONTENT).forEach((element) => {
    element.setAttribute('aria-hidden', 'false')
  })

  document.body.style.position = 'static'
  document.body.style.overflow = ''

  this.node.dataset.classname
    ? this.node.classList.remove(`${this.node.dataset.classname}--expanded`)
    : this.node.classList.remove('expanded')
}

A11yModal.prototype.captureNavigation = function () {
  let focusable = this.node.querySelectorAll(
    'a[href], button, textarea, input[type="text"], input[type="radio"], input[type="checkbox"], select',
  )
  let visibleFocusable = [...focusable].filter(
    (element) => element.offsetHeight > 0,
  )

  let firstFocusableElement = visibleFocusable[0]
  let lastFocusableElement = visibleFocusable[visibleFocusable.length - 1]

  this.node.addEventListener('keydown', (e) => {
    var isTabPressed = e.key === 'Tab' || e.keyCode === this.KEYCODE_TAB

    if (!isTabPressed) {
      return
    }

    if (e.shiftKey) {
      if (document.activeElement === firstFocusableElement) {
        lastFocusableElement.focus()
        e.preventDefault()
      }
    } else {
      if (document.activeElement === lastFocusableElement) {
        firstFocusableElement.focus()
        e.preventDefault()
      }
    }
  })
}
